"use strict";

var PlannedRoute = function () {

  var reorderNumbers = function() {
    var $last_number = 0;
    $('.route_number').each(function() {
      $(this).text($last_number+1);
      $(this).parent().parent().parent().find('.line-route-number').val($last_number+1);
      $last_number = parseFloat($(this).text());
      if ($last_number > 1) {
        $(this).parent().find('.up_button').removeClass('hidden');
        $(this).parent().find('.down_button').removeClass('hidden');
      }
    });
    if ($last_number == 1) {
      $('.route_number').first().parent().parent().find('.remove-route').addClass('hidden');  
    }
    $('.route_number').first().parent().find('.up_button').addClass('hidden');
    $('.route_number').last().parent().find('.down_button').addClass('hidden');
  }

  return {
    init: function() {

      getGeoCode();
      $(document).on('click', '.new_record_button', function(event) {
        var $last_number = 1;
        $('.route_number').each(function() {
          if ($(this).text() != '') {
            $last_number = parseFloat($(this).text());
            if ($last_number > 1) {
              $(this).parent().find('.up_button').removeClass('hidden');
              $(this).parent().find('.down_button').removeClass('hidden');
            } else {
              $(this).parent().find('.down_button').removeClass('hidden');
            }
          } else {
            $(this).text(($last_number+1));
            $(this).parent().parent().parent().find('.line-route-number').val($last_number+1);
            $(this).parent().find('.up_button').removeClass('hidden');
          }
          $(this).parent().parent().find('.remove-route').removeClass('hidden'); 
        });
        
      });

      $(document).on('click', '.up_button', function(event) {
        var parent_div = $(this).parent().parent().parent();
        var parent_number = parent_div.find('.route_number').text();
        var prev_div   = parent_div.prev();
        parent_div.find('.route_number').text((parseFloat(parent_number)-1));
        prev_div.find('.route_number').text((parseFloat(parent_number)));
        parent_div.after(prev_div);
        setTimeout(reorderNumbers(), 10000);
        event.preventDefault();
      });

      
    
      $(document).on('click', '.down_button', function(event) {
        var parent_div = $(this).parent().parent().parent();
        var parent_number = parent_div.find('.route_number').text();
        var prev_div = parent_div.next();
        parent_div.find('.route_number').text((parseFloat(parent_number)+1));
        prev_div.find('.route_number').text((parseFloat(parent_number)));
        parent_div.before(prev_div);
        setTimeout(reorderNumbers(), 10000);
        event.preventDefault();
      });
    
      $(document).on('click', '.remove-route', function(event) {
        $(this).parent().parent().parent().remove();
        setTimeout(reorderNumbers(), 10000);
      });
    }
  };
}();

if (typeof module !== 'undefined') {
	module.exports = PlannedRoute;
}